import React, { useState } from "react";
import { Box, Container, InputAdornment, Stack, TextField } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import PageBanner from "../orderStatus/components/pageBanner";
import Panel from "../orderStatus/components/whitePanel";
import Copyright from "../Copyright";
import TrackingOrderDetail from "../orderStatus/trackingOrderDetail";
import "../orderStatus/orderDetail.css";

export default function Tracking() {
    const [input, setInput] = useState("");
    const [trackingNumber, setTrackingNumber] = useState("");

    const handleSubmit = (event) => {
        event.preventDefault();
        const trimmed = input.trim();
        if (!trimmed) return;
        setTrackingNumber(trimmed);
        setInput("");
    };

    return (
        <Box className="NewOrder">
            <PageBanner title="TRACK YOUR ORDER" subheading="Enter your tracking number below" />
            <Container maxWidth="md">
                <div id="pageContent" style={{ marginTop: "-48px" }}>
                    <Panel>
                        <Stack component="form" onSubmit={handleSubmit} spacing={2} alignItems="center">
                            <TextField
                                fullWidth
                                autoFocus
                                placeholder="e.g. TR1921313473430"
                                value={input}
                                onChange={(e) => setInput(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        e.preventDefault();
                                        handleSubmit(e);
                                    }
                                }}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon sx={{ color: "text.disabled" }} />
                                        </InputAdornment>
                                    ),
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton type="submit" color="primary" disabled={!input.trim()}>
                                                <SearchIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Stack>
                    </Panel>

                    {trackingNumber && (
                        <Box sx={{ mt: 1 }}>
                            <TrackingOrderDetail
                                key={trackingNumber}
                                trackingNumberOverride={trackingNumber}
                                embedded
                                trakingType="trackingNumber"
                            />
                        </Box>
                    )}
                </div>
            </Container>
            <footer>
                <Copyright />
            </footer>
        </Box>
    );
}
